// locale/Header.js
export default {
    ja: {
        purchase: 'チケット購入',
        external_site_notice: '※外部サイトに遷移します',
        menu: {
            top: "TOP",
            contents: "CONTENTS",
            map: "MAP",
            tickets: "TICKETS",
            access: "ACCESS",
        },
        languages: {
            ja: "日本語",
            en: "English"
        }
    },
    en: {
        purchase: 'Purchase Tickets',
        external_site_notice: '※This link goes to an external site',
        menu: {
            top: "TOP",
            contents: "CONTENTS",
            map: "MAP",
            tickets: "TICKETS",
            access: "ACCESS"
        },
        languages: {
            ja: "日本語",
            en: "English"
        }
    },

};
